/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const setMockDateDaysAgo = (numDays = 0): Date => {
  const d = new Date();
  d.setDate(d.getDate() - numDays);
  d.setUTCHours(0);
  d.setUTCMinutes(0);
  d.setUTCSeconds(0);
  d.setUTCMilliseconds(0);
  return d;
};

export const getRandomInt = (min: number, max: number): number => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

export const emptyMetricData = {
  data: [
    {
      timestamp: setMockDateDaysAgo(6).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(5).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(4).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(3).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(2).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(1).toISOString(),
      value: 0,
    },
    {
      timestamp: setMockDateDaysAgo(0).toISOString(),
      value: 0,
    },
  ],
  unit: `count`,
};

export const mockMetricData = {
  data: [
    {
      timestamp: setMockDateDaysAgo(7).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(6).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(5).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(4).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(3).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(2).toISOString(),
      value: getRandomInt(0, 50),
    },
    {
      timestamp: setMockDateDaysAgo(1).toISOString(),
      value: getRandomInt(0, 50),
    },
  ],
  unit: `count`,
};
